import React, { Component } from 'react';
import { Button, Form, Input, Segment } from "semantic-ui-react";
import 'react-flags-select/css/react-flags-select.css';
import ReactFlagsSelect from 'react-flags-select';

/** Allows the user to choose a country, construction type, and floor area. */
class ConstructionParameters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            floorArea: props.initialFloorArea || 1000,
            typeSelectValue: 0,     
            typeOptions: []
        }

        this.countrySelectRef = React.createRef();
    }


    onCountryChange = (countryCode) => {
        // Set the construction type to the first item in the list.
        this.setState({
            typeSelectValue: 0
        });
        
        this.props.onCountryChange && this.props.onCountryChange(countryCode);
    }


    onFloorAreaChange = (e, ctl) => {
        this.setState(prevState => {
            let val = 0;
            if (ctl.name === 'btnIncreaseFloorArea') {
                val = parseInt(prevState.floorArea) + 10;
            } else if(ctl.name === 'btnDecreaseFloorArea' && parseInt(this.state.floorArea) > 10) {
                val = parseInt(prevState.floorArea) - 10;
            } else if(ctl.name === 'floorArea' && !isNaN(ctl.value)) {
                val = ctl.value;
            }
            return {floorArea: val};
        }, () => (this.props.onFloorAreaChange && this.props.onFloorAreaChange(this.state.floorArea)));
        
    }

    onTypeChange = (e, { value }) => {
        this.setState({
            typeSelectValue: value
        }, () => (this.props.onTypeChange && this.props.onTypeChange(this.props.country.categories[value])));
    }

    componentDidUpdate(prevProps) {

        // If first loaded or the country has changed.
        if (prevProps.country !== this.props.country) {

            // Force ReactFlagsSelect to display the country instead of
            // the search placeholder text.
            if (this.countrySelectRef.current) {                
                this.countrySelectRef.current.updateSelected(this.props.country.id);
            }

            // Build the values for the construction type 
            this.setState({typeOptions: this.props.country.categories.map((c, i) => ({key: i, text: c.name, value: i}))});
        }
	}

    render() {       
        return (
            <Segment color='blue' raised={true} loading={this.props.loading} >
                <Form>
                    <Form.Group widths='equal'>
                        <Form.Field>
                            <label>Country</label>
                            <ReactFlagsSelect
                                ref={ this.countrySelectRef }
                                countries={this.props.countryCodes}
                                searchable={true}
                                searchPlaceholder="Search..."
                                selectedSize={14}
                                className="menu-flags"
                                onSelect={this.onCountryChange} />
                        </Form.Field>
                        <Form.Select
                            fluid={true}
                            label='Construction type'
                            onChange={this.onTypeChange}
                            options={ this.state.typeOptions }
                            value={this.state.typeSelectValue} />
                        <Form.Field>
                            <label>Floor area in square {this.props.country.measurement === 'imperial' ? 'feet' : 'meters'}</label>
                            <Input name='floorArea' type='text'
                                action={true}
                                fluid={true}
                                value={this.state.floorArea}
                                onChange={this.onFloorAreaChange}
                                min={0}>
    
                                <input />
                                <Button name='btnIncreaseFloorArea'
                                    className='navy'
                                    icon='arrow up'
                                    onClick={this.onFloorAreaChange} />
                                <Button name='btnDecreaseFloorArea'
                                    className='navy'
                                    icon='arrow down'
                                    onClick={this.onFloorAreaChange} />
                            </Input>
    
                        </Form.Field>
    
                    </Form.Group>
                </Form>
            </Segment>
    
        );
    }
}

export default ConstructionParameters;